import md5Hex from 'md5-hex';

export function md5(value: string): string {
  try {
    return md5Hex(value);
  } catch (e) {
    console.warn('Not hashed');
    return '';
  }
}